import RenderManager from "../rendering/render-manager";
import { fire } from "../utils/events";
import Network from "../miniviews/network";
import AssessmentManager from "../assessment/assessment-manager";
import QuizManager from "../quizes/quiz-manager";
import SlideManager from "../utils/slide-manager";
import getVWKey from "../helpers/getVWKey";
import TransformControlsPivotWrapper from "../pivots/transform-controls-wrapper";

let transformControls;
function addTransformWidget(pivotSetterGetter) {
    let controlsOriginal = new THREE.TransformControls(RenderManager.activeCamera, RenderManager.domElement);
    transformControls = new TransformControlsPivotWrapper(controlsOriginal, pivotSetterGetter);

    transformControls.addEventListener("change", onChange);
    transformControls.addEventListener("objectChange", onObjectChange);
    transformControls.addEventListener("mouseDown", onMouseDown);
    transformControls.addEventListener("mouseUp", onMouseUp);

    transformControls.visible = false;

    transformControls.traverse(child => {
        if (child.material) {
            child.material.fog = false;
            child.renderOrder = Infinity;
            child.material.needsUpdate = true;
        }
    });

    RenderManager.root.add(controlsOriginal);

    Q3.transformControls = transformControls;
}

export default addTransformWidget;
export { addTransformWidget };

function enableControls() {
    if (!SlideManager.currentSlide.camera.disabled) {
        Q3.controls.enabled = true;
    }

    if (Q3.controls.isFPSControls) Q3.controls.activate();
    document.removeEventListener("mouseup", enableControls);
}

function onChange() {
    RenderManager.activeCamera.update = true;
    RenderManager.shadowMap.needsUpdate = true;

    if (QuizManager.isStateFlipped)
        return;

    fire("transformchange");
}

function onObjectChange() {
    if (QuizManager.isStateFlipped) return;

    fire("objectchange");
}

function onMouseDown() {
    fire("start_transform");
    if (QuizManager.isStateFlipped) return;

    fire("start_transform");

    Q3.controls.enabled = false;
    if (Q3.controls.isFPSControls) Q3.controls.deactivate();

    document.addEventListener("mouseup", enableControls);

    Q3.container.classList.add("transforming-object");

    Object.keys(Q3.layers.list).forEach(layerUuid => {
        const layer = Q3.layers.list[layerUuid];

        if (layer.objects && layer.objects.length) {
            layer.objects.forEach(object => {
                object.domElement.classList.toggle("q3-object-grab-hide");
            });
        }
    });
}

function onMouseUp() {
    fire("finish_transform");
    if (QuizManager.isStateFlipped) return;

    updateQ3Data(transformControls.object.uuid);

    fire("transformfinishchange", transformControls.object.uuid);
    fire("finish_transform");

    if (Q3.editMode) Q3.showSnackBar("Transformation saved");

    setTimeout(function () { Q3.container.classList.remove("transforming-object"); }, 500);

    Object.keys(Q3.layers.list).forEach(layerUuid => {
        const layer = Q3.layers.list[layerUuid];

        if (layer.objects && layer.objects.length) {
            layer.objects.forEach(object => {
                object.domElement.classList.toggle("q3-object-grab-hide");
            });
        }
    });
}

function updateQ3Data(uuid) {
    const obj = Q3.assets.objects[uuid] || Q3.assets.lights[uuid];

    if (!obj) return;

    if (Q3.data.assets.objects[Q3.selected.uuid]) {
        const vpType = getVWKey();
        const data = SlideManager.currentSlide.animation[uuid];
        const saveObject = vpType === "sizeSm"
            ? data[vpType] = data[vpType] || {
                position: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
                rotation: { x: 0, y: 0, z: 0 }
            }
            : data;

        const containers = [saveObject];

        ["position", "rotation", "scale"].forEach(key => {
            ["x", "y", "z"].forEach(axis => {
                containers.forEach(container => {
                    container[key][axis] = obj[key][axis];
                });
            });
        });
    }
}